import React, {Fragment, useEffect, useState} from 'react'
import Fab from '@material-ui/core/Fab';
import Spinner from '../components/Spinner'
import { logPage, logEvent, pushToDataLayer } from '../components/Analytics';

const SubscriptionModal = ({setCamp, campaign, buttonDisabled, action, errorMessage}) => {
    
    const [modalOpen, setModalOpen] = useState(true);
    return (
        <Fragment>
            <div style={{display: `${!modalOpen ? 'none' : 'block'}` }}>
                <div className="overlay-color"></div>
                <div className="modal-popup">
                    <h1>Just nu: upp till 30% rabatt</h1>
                    {/* <p>Erbjudandet avslutas 23:59 31/03/2020</p> */}

                    <div className="checkboxes desktop">
                        <div className="checkbox-clm first-box">
                            <input type="radio" name="lock" checked={campaign === 'common' ? 'checked' : ''} onChange={() => setCamp('common')}/>
                            <div className="checkbox-content">
                                <span className="top-line">ORdinarie</span>
                                <h2><strong>99</strong> kr/mån</h2>
                                <span className="redbar">Ingen bindningstid</span>
                            </div>
                        </div>

                        <div className="checkbox-clm">
                            <input type="radio" name="lock" checked={campaign === 'sixMonthLock' ? 'checked' : ''} onChange={() => setCamp('sixMonthLock')}/>
                            <div className="checkbox-content">
                                <span className="red-btn">Spara 120 kr</span>
                                <span className="top-line">6 månader</span>
                                <h2><strong>79</strong> kr/mån</h2>
                                <span className="redbar">Bindningstid*</span>
                            </div>
                        </div>

                        <div className="checkbox-clm">
                            <input type="radio" name="lock" checked={campaign === 'twelveMonthLock' ? 'checked' : ''} onChange={() => setCamp('twelveMonthLock')}/>
                            <div className="checkbox-content">
                            <span className="red-btn">Spara 360 kr</span>
                                <span className="top-line">12 månader</span>
                                <h2><strong>69</strong> kr/mån</h2>
                                <span className="redbar">Bindningstid*</span>
                            </div>
                        </div>
                    </div>


                    <div className="mobile-checkboxes checkboxes for-mobile">
                           <div className="checkbox-clm first-box">
                           <input type="radio" name="m-lock" checked={campaign === 'common' ? 'checked' : ''} onChange={() => setCamp('common')}/>
                            <div className="checkbox-content d-table">
                                    <div className="d-table-cell icon-clm">
                                        <i className="circle-icon"></i>
                                    </div>
                                    <div className="d-table-cell price-clm">
                                        <h2><strong>99</strong> kr/mån</h2>
                                        <span className="redbar">Bindningstid*</span>
                                    </div>
                                    <div className="d-table-cell man-clm">
                                        <span className="top-line">ORdinarie</span>
                                    </div>
                                </div>  
                           </div> 

                           <div className="checkbox-clm">
                           <input type="radio" name="m-lock" checked={campaign === 'sixMonthLock' ? 'checked' : ''} onChange={() => setCamp('sixMonthLock')}/>
                            <div className="checkbox-content d-table">
                                    <div className="d-table-cell icon-clm">
                                        <i className="circle-icon"></i>
                                    </div>
                                    <div className="d-table-cell price-clm">
                                        <h2><strong>79</strong> kr/mån</h2>
                                        <span className="redbar">Bindningstid*</span>
                                    </div>
                                    <div className="d-table-cell man-clm">
                                        <span className="top-line">6 mån</span>
                                        <span className="red-btn">Spara 120 kr</span>
                                    </div>
                                </div>  
                           </div> 

                            <div className="checkbox-clm">
                           <input type="radio" name="m-lock" checked={campaign === 'twelveMonthLock' ? 'checked' : ''} onChange={() => setCamp('twelveMonthLock')}/>
                            <div className="checkbox-content d-table">
                                    <div className="d-table-cell icon-clm">
                                        <i className="circle-icon"></i>
                                    </div>
                                    <div className="d-table-cell price-clm">
                                        <h2><strong>69</strong> kr/mån</h2>
                                        <span className="redbar">Bindningstid*</span>
                                    </div>
                                    <div className="d-table-cell man-clm">
                                        <span className="top-line">12 mån</span>
                                        <span className="red-btn">Spara 360 kr</span>
                                    </div>
                                </div>  
                           </div>  
                           
                    </div>

                    <div className="bottom___line desktop">
                        <p>*Erbjudandet debiteras månadsvis och gäller 6 och 12 månaders bindningstid. Vald prenumeration förnyas löpande. Hantera din prenumeration enkelt genom att logga in på Mina Sidor.</p>
                    </div>
                    <div className="bottom___line for-mobile">
                        <p>*Erbjudandet debiteras månadsvis och gäller 6 och 12 månaders bindningstid. Vald prenumeration förnyas löpande. Hantera din prenumeration enkelt genom att logga in på Mina Sidor.</p>
                    </div>
                    <label className="text-error">{errorMessage}</label>
                    <div style={{position: "relative"}}>
                        <Fab
                            variant="extended"
                            color="primary"
                            aria-label="Add"
                            className="registerButton"
                            disabled={buttonDisabled}
                            onClick={() => {
                                    action();
                                    logEvent(
                                        `Start page register payment button`,
                                        `Start page register payment button was clicked`
                                    );
                                    pushToDataLayer(
                                        'userClick',
                                        'Start Page Register Payment Button',
                                        'Start Page Register Payment Button Was Clicked'
                                    )
                                }
                            }
                            >
                            Påbörja din gratisperiod
                        </Fab>
                        {
                            buttonDisabled && (
                                <Spinner size={48} />
                            )
                        }
                    </div>
                                        
                </div>
            </div>
        </Fragment>
    )
}

export default SubscriptionModal;